import {
  Box,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';

import {
  formatMoney,
  formatMoneyBack,
} from '../../../../../../../../../lib/functions/utils';

const useStyles = makeStyles(() =>
  createStyles({
    table: {
      width: '100%',
    },
    tableCell: {
      padding: '8px !important',
      overflow: 'hidden',
      minWidth: '100px',
      whiteSpace: 'nowrap',
      fontSize: '14px !important',
    },
    tableContainer: {
      border: '1px solid #e0e0e0',
      borderRadius: '10px',
    },
    tableBody: {
      backgroundColor: '#ffffff',
    },
    textField: {
      fontSize: '14px !important',
      padding: '8px !important',
    },
    iconButton: {
      padding: '5px',
    },
  }),
);

const NullmentTable = (props: any) => {
  const { nullments, setNullments } = props;
  const classes = useStyles();

  const handleChangeNullment = (value: any, key: string, rowIndex: number) => {
    const newNullments = nullments.map((doc: any, i: any) => {
      if (i === rowIndex) {
        // Si cambia el tipo de anulación
        if (key === 'nullmentType') {
          if (value === 1) {
            // Completa: Restaurar el monto original
            return {
              ...doc,
              nullmentType: value,
              amount: doc.originalAmount,
            };
          } else {
            // Parcial (2): establecer en originalAmount - 1
            return {
              ...doc,
              nullmentType: value,
              amount: doc.originalAmount - 1,
            };
          }
        }

        // Si cambia el monto (solo en anulación parcial)
        if (key === 'amount') {
          const numericValue = formatMoneyBack(value);
          // Validar que esté entre 1 y (originalAmount - 1)
          if (numericValue > 0 && numericValue < doc.originalAmount) {
            return {
              ...doc,
              amount: numericValue,
            };
          }
          // Si el valor no es válido, mantener el monto anterior
          return doc;
        }

        return {
          ...doc,
          [key]: value,
        };
      }
      return doc;
    });
    setNullments(newNullments);
  };

  return (
    <TableContainer className={classes.tableContainer}>
      <Table className={classes.table}>
        <TableHead style={{ background: '#efefef' }}>
          <TableRow>
            <TableCell className={classes.tableCell}>Folio</TableCell>
            <TableCell
              className={classes.tableCell}
              style={{ textAlign: 'left' }}
            >
              Tipo Doc.
            </TableCell>
            <TableCell
              className={classes.tableCell}
              style={{ textAlign: 'left' }}
            >
              Rut Deudor
            </TableCell>
            <TableCell
              className={classes.tableCell}
              style={{ textAlign: 'left' }}
            >
              Nombre Deudor
            </TableCell>
            <TableCell
              className={classes.tableCell}
              style={{ textAlign: 'left' }}
            >
              Tipo Anulación
            </TableCell>
            <TableCell
              className={classes.tableCell}
              style={{ textAlign: 'left' }}
            >
              Fecha Emisión
            </TableCell>
            <TableCell
              className={classes.tableCell}
              style={{ textAlign: 'right' }}
            >
              Monto Neto
            </TableCell>
            <TableCell
              className={classes.tableCell}
              style={{ textAlign: 'right' }}
            >
              IVA
            </TableCell>
            <TableCell
              className={classes.tableCell}
              style={{ textAlign: 'right' }}
            >
              Total
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={classes.tableBody}>
          {nullments.map((row: any, rowIndex: number) => {
            const isPartial = row.nullmentType === 2; // 2 = Parcial
            const iva = row.amount * 0.19;
            const total = row.amount * 1.19;

            return (
              <TableRow key={rowIndex}>
                <TableCell className={classes.tableCell}>{row.folio}</TableCell>
                <TableCell className={classes.tableCell}>
                  {row.docType}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  {row.stakeholderIdentifier}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  {row.stakeholderName}
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Select
                    value={row.nullmentType}
                    onChange={(e) =>
                      handleChangeNullment(
                        e.target.value,
                        'nullmentType',
                        rowIndex,
                      )
                    }
                    fullWidth
                    size="small"
                  >
                    <MenuItem value={1}>Completa</MenuItem>
                    <MenuItem value={2}>Parcial</MenuItem>
                  </Select>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <TextField
                    value={row.issuedDate ? row.issuedDate.split('T')[0] : ''}
                    type="date"
                    onChange={(e) =>
                      handleChangeNullment(
                        e.target.value,
                        'issuedDate',
                        rowIndex,
                      )
                    }
                    InputProps={{
                      classes: { input: classes.textField },
                    }}
                    size="small"
                  />
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {isPartial ? (
                    <Box>
                      <TextField
                        value={formatMoney(row.amount)}
                        inputProps={{
                          style: { textAlign: 'right' },
                        }}
                        onChange={(e) =>
                          handleChangeNullment(
                            e.target.value,
                            'amount',
                            rowIndex,
                          )
                        }
                        InputProps={{
                          classes: { input: classes.textField },
                        }}
                        size="small"
                      />
                    </Box>
                  ) : (
                    formatMoney(row.amount)
                  )}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(iva)}
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  style={{ textAlign: 'right' }}
                >
                  {formatMoney(total)}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default NullmentTable;
